import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import { Container } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import classes from "../Search/Search.module.css";
import Footer from "../Footer/Footer";
import { Grid, Stack, Typography, Pagination, Box, Chip, ToggleButton, ToggleButtonGroup } from "@mui/material";
import ExploreCard from "./ExploreCard";
import { useSearchParams } from "react-router-dom";
import ExploreGrid from "./ExploreGrid";
import AddInteractionDialog from "./AddInteractionDialog";
import { Button } from "@mui/material";

import {
  getTagData,
  getImplCustomers,
  getImplTags,
  getViewsCount,
  getKnownSince,
  getContactsWithoutDossier,
  getExploreTags,
  getExploreTagContacts,
  getCustomersWithActionPlan,
  getCustomersWithoutActionPlan
} from "./Network_Calls";

const ExploreJourney = () => {
  const [select, setSelect] = useState("");
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(false);
  const [implementations, setImplementations] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [filterdList, setFilteredList] = useState([]);
  const [filterState, setFilterstate] = useState(false);
  const [implTags, setImplTags] = useState([]);
  const [impl_id, setImpl_id] = useState();
  const [view, setView] = useState(false);
  const [most_viewed, setmost_viewd] = useState([]);
  const [uniqueData, setUniqueData] = useState([]);
  const [leastViewData, setLeastViewData] = useState([]);
  const [recommendedData, setRecommendedData] = useState([]);
  const [recentPage, setRecentPage] = useState(1);
  const [leastViewPage, setLeastViewPage] = useState(1);
  const [recommendedPage, setRecommendedPage] = useState(1);
  const [recentRowsPerPage, setRecentRowsPerPage] = useState(6);
  const [leastViewRowsPerPage, setLeastViewRowsPerPage] = useState(6);
  const [recommendedRowsPerPage, setRecommendedRowsPerPage] = useState(6);
  const [topEngagementData, setTopEngagementData] = useState([]);
  const [topEngagementPage, setTopEngagementPage] = useState(1);
  const [topEngagementRowsPerPage] = useState(6);
  const [firstContactData, setFirstContactData] = useState([]);
  const [firstContactPage, setFirstContactPage] = useState(1);
  const [firstContactRowsPerPage] = useState(6);
  const [firstContactFilter, setFirstContactFilter] = useState("30days");
  const [knownSinceFilter, setKnownSinceFilter] = useState("2021-present");
  const [knownSinceData, setKnownSinceData] = useState([]);
  const [knownSincePage, setKnownSincePage] = useState(1);
  const [knownSinceRowsPerPage] = useState(6);
  const [knownSinceLoading, setKnownSinceLoading] = useState(false);
  const [firstContactLoading, setFirstContactLoading] = useState(false);
  const [lastStageSummary, setLastStageSummary] = useState([]);
  const [lastStageCustomers, setLastStageCustomers] = useState([]);
  const [selectedStage, setSelectedStage] = useState("");
  const [viewMode, setViewMode] = useState("cards");

  const [contactsWithoutDossierData, setContactsWithoutDossierData] = useState([]);
  const [contactsWithoutDossierLoading, setContactsWithoutDossierLoading] = useState(false);
  const [contactsWithoutDossierPage, setContactsWithoutDossierPage] = useState(1);
  const [contactsWithoutDossierRowsPerPage] = useState(6);

  const [browseTags, setBrowseTags] = useState([]);

  const [selectedTag, setSelectedTag] = useState(null);

  const [browseTagContacts, setBrowseTagContacts] = useState([]);

  const [browseTagsLoading, setBrowseTagsLoading] = useState(false);

  const [browseTagContactsLoading, setBrowseTagContactsLoading] = useState(false);

  const [browseTagPage, setBrowseTagPage] = useState(1);

  const [browseTagRowsPerPage] = useState(6);

  const [customersWithActionPlanData, setCustomersWithActionPlanData] = useState([]);

  const [customersWithActionPlanLoading, setCustomersWithActionPlanLoading] = useState(false);

  const [customersWithActionPlanPage, setCustomersWithActionPlanPage] = useState(1);

  const [customersWithActionPlanRowsPerPage] = useState(6);


  const [customersWithoutActionPlanData, setCustomersWithoutActionPlanData] = useState([]);

  const [customersWithoutActionPlanLoading, setCustomersWithoutActionPlanLoading] = useState(false);

  const [customersWithoutActionPlanPage, setCustomersWithoutActionPlanPage] = useState(1);

  const [customersWithoutActionPlanRowsPerPage] = useState(6);

  const [stagePage, setStagePage] = useState(1);
  const [stageRowsPerPage] = useState(6);

  const [openInteractionModal, setOpenInteractionModal] = useState(false);

  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [searchParams] = useSearchParams();

  const journeyType = searchParams.get("type") || "Contact360";

  const stageOffset = (stagePage - 1) * stageRowsPerPage;

  const handleStagePageChange = (event, page) => {
      setStagePage(page);
  };
  const kanbanData = lastStageSummary.map(stage => ({
      stage: stage.stage,
      customers: lastStageCustomers.filter(
          customer => customer.stage === stage.stage
      )
  }));
  const firstContactOffset = (firstContactPage - 1) * firstContactRowsPerPage;

  const knownSinceOffset = (knownSincePage - 1) * knownSinceRowsPerPage;

  const contactsWithoutDossierOffset = (contactsWithoutDossierPage - 1) * contactsWithoutDossierRowsPerPage;

  const browseTagOffset = (browseTagPage - 1) * browseTagRowsPerPage;

  const customersWithActionPlanOffset = (customersWithActionPlanPage - 1) * customersWithActionPlanRowsPerPage;

const customersWithoutActionPlanOffset = (customersWithoutActionPlanPage - 1) * customersWithoutActionPlanRowsPerPage;

  const handleKnownSincePageChange = (event, page) => {
    setKnownSincePage(page);
  };

  const handleContactsWithoutDossierPageChange = (event, page) => {
    setContactsWithoutDossierPage(page);
  };

  const handleBrowseTagPageChange = ( event, page ) => {
    setBrowseTagPage(page);
  };

  const handleCustomersWithActionPlanPageChange = (
    event,
    page
  ) => {
    setCustomersWithActionPlanPage(page);
  };


  const handleCustomersWithoutActionPlanPageChange = (
    event,
    page
  ) => {
    setCustomersWithoutActionPlanPage(page);
  };

  const handlefirstContactPageChange = (event, page) => {
      setFirstContactPage(page);
  };

  const knownSinceTitles = {
    "2021-present": "Known Since (2021 - Present)",
    "2010-2020": "Known Since (2010 - 2020)",
    "2000-2010": "Known Since (2000 - 2010)",
  };

  console.log("imp id", impl_id);
  console.log("item name", select);
  console.log("Recent Views", uniqueData);
  console.log("Least Views", leastViewData);
  console.log("Recommended views", recommendedData);

  // Pagination Change Handlers
  const handleRecentPageChange = (event, page) => {
    setRecentPage(page);
  };

  const handleLeastViewPageChange = (event, page) => {
    setLeastViewPage(page);
  };

  const handleOpenInteraction = (customer) => {
    setSelectedCustomer(customer);
    setOpenInteractionModal(true);
  };

  const topEngagementOffset = (topEngagementPage - 1) * topEngagementRowsPerPage;

  const handleTopEngagementPageChange = (event, page) => {
      setTopEngagementPage(page);
  };

  // Pagination calculations
  // const topEngagementOffset = (topEngagementPage - 1) * topEngagementRowsPerPage;
  const leastViewOffset = (leastViewPage - 1) * leastViewRowsPerPage;
  const recommendedOffset = (recommendedPage - 1) * recommendedRowsPerPage;

  const filterTitles = {
    "30days": "First Contact - Last 30 Days",
    "60days": "First Contact - Last 60 Days",
    "90days": "First Contact - Last 90 Days",
    "thisYear": "First Contact - This Year",
    "lastYear": "First Contact - Last Year",
  };


  const taggingData = async (data, state) => {
    console.log(data);
    // data.id === null && data.tags === "empty"
    if (state) {
      setFilterstate(false);
    } else {
      try {
        // console.log(tagInfo);
        console.log(data.id);
        // const resp = await getTagData(data.id ? data.id : tagInfo);
        const resp = await getTagData(data.id);
        const result = await resp.data;
        // console.log(result, "jjjjj");
        if (result.message === "successfully fetched") {
          const arr = result.list.map((e) => e.customer_id);

          const tagData = customerList.filter((cus) => {
            return arr.includes(cus._id);
          });
          setFilterstate(true);
          // setTagInfo(result.tag_id);
          setFilteredList([...tagData]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const implSelect = async (impl) => {
    setSelect(impl.item_name);
    setImpl_id(impl._id);
    // setImplementationName(impl.item_name);
    if (impl._id) {
      setFilterstate(false);
    }

    try {
      setView(true);
      console.log(impl.item_name);
      const result = await getImplCustomers(impl.item_name);

      if (result.data.msg === "Generated") {
        const views = result.data.views.slice(0, 6);
        setmost_viewd([...views]);
        setCustomerList([...result.data.users]);
        setView(false);
      }
      const response = await getImplTags(impl._id);
      // console.log(response);
      if (response.data.message === "success") {
        setImplTags([...response.data.implTags]);
        setView(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadTagContacts = async (
    tagId
) => {

    try{

        setBrowseTagContactsLoading(true);

        const result =
            await getExploreTagContacts(

                select,

                journeyType,

                tagId

            );

        if(result.status===200){

            setBrowseTagContacts(
                result.data.contacts
            );

        }

    }catch(error){

        console.log(error);

    }finally{

        setBrowseTagContactsLoading(false);

    }

  };

  let typeOfJourney =
    select !== ""
      ? implementations.filter((x) => x.item_name === select)
      : [{ usertype: "Customer" }];

  useEffect(() => {
    try {
      (async () => {
        setLoading(true);

        // const result = await getOrganizationUser();

        if (true) {
          setErr(false);
          setLoading(false);
          // setImplementations(result.data.list);

          // setImplementationName(result.data.list[0].item_name);
          // const response = await getImplTags(result.data.list[0]._id);
          // console.log(response);
          // if (response.data.message === "success") {
          //     setImplTags([...response.data.implTags]);
          // }
          setSelect(localStorage.getItem("tagname"));
          setImpl_id(Number(localStorage.getItem("tag_id")));
          const resp = await getImplCustomers(localStorage.getItem("tagname"));
          if (resp.data.msg === "Generated") {
            const views = resp.data.views.slice(0, 6);
            setmost_viewd([...views]);
            setCustomerList([...resp.data.users]);
          }
        } else {
          setErr(true);
        }
      })();
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    const loadFirstContactData = async () => {
      try {
        setFirstContactLoading(true);
        setFirstContactData([]);

        const result = await getViewsCount(select, firstContactFilter, journeyType);

        if (result && result.status === 200) {
          const {
            recentViews,
            leastViewCustomers,
            recommendedViews,
            topEngagement,
            firstContact30,
          } = result.data;

          setUniqueData(recentViews);
          setLeastViewData(leastViewCustomers);
          setRecommendedData(recommendedViews);
          setTopEngagementData(topEngagement);
          setFirstContactData(firstContact30);
          setLastStageSummary(result.data.lastStageSummary || []);
          setLastStageCustomers(result.data.lastStageCustomers || []);
          await loadKnownSinceData();
          setUniqueData(result.data.recentViewedExplore);
          setLeastViewData(result.data.leastViewedExplore);
          const stages = result.data.lastStageSummary || [];
          if (stages.length > 0) {
              setSelectedStage(stages[0].stage);
          }
        }
      } catch (error) {
        console.error(error);
        setErr(true);
      } finally {
        setFirstContactLoading(false);
      }
    };

    loadFirstContactData();
  }, [select, firstContactFilter, journeyType]);

const loadKnownSinceData = async () => {

        try {

            setKnownSinceLoading(true);

            const result = await getKnownSince(
                select,
                journeyType,
                knownSinceFilter
            );

            if (result?.status === 200) {
                setKnownSinceData(result.data.knownSince || []);
                await loadContactsWithoutDossierData();
            }

        } catch (err) {

            console.log(err);

        } finally {

            setKnownSinceLoading(false);

        }

    };
  
    const loadContactsWithoutDossierData = async () => {

    try{

        setContactsWithoutDossierLoading(true);

        const result =
            await getContactsWithoutDossier(
                select,
                journeyType
            );

        if(result?.status===200){

            setContactsWithoutDossierData(
                result.data.contactsWithoutDossier || []
            );

        }

        await loadBrowseTags();
        if (journeyType === "Customer") {
          await loadActionPlanCustomers();
        }

    }
    catch(err){

        console.log(err);

    }
    finally{

        setContactsWithoutDossierLoading(false);

    }

};

const loadBrowseTags = async () => {

    try{

        setBrowseTagsLoading(true);

        const result =
            await getExploreTags(
                select,
                journeyType
            );

        if(result.status===200){

            setBrowseTags(
                result.data.tags || []
            );

            if(result.data.tags.length){

                const firstTag = result.data.tags[0];

                setSelectedTag(firstTag);

                await loadTagContacts(firstTag.tag_id);

            }

        }

    }
    catch(err){

        console.log(err);

    }
    finally{

        setBrowseTagsLoading(false);

    }

  };

  const loadActionPlanCustomers = async () => {

    try {

      setCustomersWithActionPlanLoading(true);
      setCustomersWithoutActionPlanLoading(true);

      const [
        withActionPlanResponse,
        withoutActionPlanResponse
      ] = await Promise.all([

        getCustomersWithActionPlan(
          select,
          journeyType
        ),

        getCustomersWithoutActionPlan(
          select,
          journeyType
        )

      ]);

      if (
        withActionPlanResponse?.status === 200
      ) {

        setCustomersWithActionPlanData(
          withActionPlanResponse.data.customers || []
        );

      }

      if (
        withoutActionPlanResponse?.status === 200
      ) {

        setCustomersWithoutActionPlanData(
          withoutActionPlanResponse.data.customers || []
        );

      }

    } catch (error) {

      console.log(
        "Action Plan loading error:",
        error
      );

    } finally {

      setCustomersWithActionPlanLoading(false);
      setCustomersWithoutActionPlanLoading(false);

    }

  };

 const filteredStageCustomers =
    lastStageCustomers.filter(
        x => x.stage === selectedStage
    );

  const getContactStatus = (updateDate) => {
    if (!updateDate) {
      return {
        label: "No Contact",
        color: "default",
        border: "#9E9E9E",
      };
    }

    const today = new Date();
    const lastContact = new Date(updateDate);

    const diffDays = Math.floor(
      (today - lastContact) / (1000 * 60 * 60 * 24)
    );

    if (diffDays <= 30) {
      return {
        label: "Recently Engaged",
        color: "success",
        border: "#2E7D32",
      };
    }

    if (diffDays <= 60) {
      return {
        label: "Follow Up Soon",
        color: "warning",
        border: "#F9A825",
      };
    }

    if (diffDays <= 90) {
      return {
        label: "Attention Needed",
        color: "warning",
        border: "#EF6C00",
      };
    }

    return {
      label: "Critical",
      color: "error",
      border: "#D32F2F",
    };
  };

  const getJourneyRoute = (journeyType) => {
    switch (journeyType) {
      case "Employee":
        return "Employee";

      case "Customer":
        return "Customer";

      case "Supplier":
        return "Supplier";

      case "Product":
        return "Product";

      case "Project":
        return "Project";

      case "Contact":
      case "Contact360":
        return "Contact360";

      default:
        return "Contact360";
    }
  };


  const prepareGridRows = (data = []) => {
    return data.map((item) => {
      const status = getContactStatus(item.update_date);

      return {
        id: item.external_id || item._id,
        external_id: item.external_id || item._id,
        username: item.username,
        engagement_score: item.engagement_score,
        interaction_count: item.interaction_count,
        customer_views: item.customer_views,

        update_date: item.update_date,
        known_since: item.known_since,
        first_contact_date: item.first_contact_date,

        stage: item.stage,

        status: status.label,
        statusColor: status.border,

        journeyRoute: getJourneyRoute(item.journey_type || journeyType),
        tagId: localStorage.getItem("tag_id"),
      };
    });
  };


  return (
    <>
      <Navbar />
      <div style={{ display: "flex" }}>
        <Container>
          <div>
            {/* {loading ? (
                    <>
                        <p className={classes.loader}>
                        <span className={classes.spinner}></span>
                        <span>Loading...</span>
                        </p>
                        <SkeletonLoader />
                    </>
                    ) : implementations.length !== 0 ? (
                    <div className={classes.optionMain}>
                        {implementations.length >= 0 ? (
                            implementations.map((impl, index) => (
                                <div
                                key={index}
                                className={
                                    select === impl.item_name
                                    ? classes.optionCardSelect
                                    : classes.optionCard
                                }
                                onClick={() => implSelect(impl)}
                                >
                                {impl.item_name}
                                </div>
                            ))
                        ) : (
                        <p></p>
                        )}
                    </div>
                    ) : (
                    <div className={classes.noData}>
                        <h4>No data found</h4>
                    </div>
                    )} */}
          </div>
          {!view ? (
            <div>
              <br />
              <div className={classes.search}>
                <h1>
                  <span className={classes.customer}>
                    {/* {typeOfJourney[0].usertype + " " || "-"} */}
                  </span>
                  <span className={classes.journey}>Explore {journeyType} Journey</span>
                </h1>
              </div>

              <div>
                <br></br>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    gap: 2,
                    mb: 3,
                  }}
                >
                  <Chip
                    label="🟢 Recently Engaged (0 - 30 Days)"
                    sx={{
                      bgcolor: "#E8F5E9",
                      color: "#2E7D32",
                      fontWeight: 600,
                    }}
                  />

                  <Chip
                    label="🟡 Follow Up Soon (31 - 60 Days)"
                    sx={{
                      bgcolor: "#FFF8E1",
                      color: "#F9A825",
                      fontWeight: 600,
                    }}
                  />

                  <Chip
                    label="🟠 Attention Needed (61 - 90 Days)"
                    sx={{
                      bgcolor: "#FFF3E0",
                      color: "#EF6C00",
                      fontWeight: 600,
                    }}
                  />

                  <Chip
                    label="🔴 Critical (> 90 Days)"
                    sx={{
                      bgcolor: "#FFEBEE",
                      color: "#D32F2F",
                      fontWeight: 600,
                    }}
                  />
                </Box>
                <Box
                      sx={{
                          display: "flex",
                          justifyContent: "center",
                          mb: 4,
                      }}
                  >
                <ToggleButtonGroup
                      value={viewMode}
                      exclusive
                      onChange={(e, value) => {
                          if (value) setViewMode(value);
                      }}
                  >

                  <ToggleButton value="cards">
                  Card View
                  </ToggleButton>

                  <ToggleButton value="kanban">
                  Kanban View
                  </ToggleButton>

                  <ToggleButton value="grid">
                      Grid View
                  </ToggleButton>

                  </ToggleButtonGroup>
                  </Box>
                {viewMode === "cards" && (
                  <>
                  <div>
                    <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            fontSize: "2rem",
                            fontWeight: "bold",
                            color: "rgb(255,118,43)",
                        }}
                    >
                        Recently Viewed
                    </Typography>

                    <br />

                    {firstContactLoading ? (
                      <Box
                          sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: 250,
                          }}
                      >
                          <CircularProgress />
                      </Box>
                  ) : (
                      <>
                          <Stack spacing={2}>
                              <Grid
                                  container
                                  spacing={{ xs: 2, md: 3 }}
                                  columns={{ xs: 4, sm: 8, md: 12 }}
                              >
                                  {uniqueData
                                      .slice(
                                          (recentPage - 1) * recentRowsPerPage,
                                          recentPage * recentRowsPerPage
                                      )
                                      .map((customerData, index) => (
                                          <Grid item xs={2} sm={4} md={4} key={index}>
                                              <ExploreCard
                                                  customerData={customerData}
                                                  status={getContactStatus(customerData.update_date)}
                                                  journeyRoute={getJourneyRoute(customerData.journey_type)}
                                                  tagId={localStorage.getItem("tag_id")}
                                                  showLastContact
                                                  onAddInteraction={handleOpenInteraction}
                                              />
                                          </Grid>
                                      ))}
                              </Grid>
                          </Stack>

                          <Pagination
                              count={Math.ceil(uniqueData.length / recentRowsPerPage)}
                              page={recentPage}
                              onChange={handleRecentPageChange}
                              variant="outlined"
                              shape="rounded"
                              sx={{
                                  mt: 3,
                                  display: "flex",
                                  justifyContent: "center",
                              }}
                          />
                      </>
                  )}
                </div>
                <div>
                  <br /><br />

                  <Typography
                      gutterBottom
                      variant="h5"
                      component="div"
                      sx={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: "2rem",
                          fontWeight: "bold",
                          color: "rgb(255,118,43)",
                      }}
                  >
                      Least Viewed
                  </Typography>

                  <br />

                  {firstContactLoading ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: 250,
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        <Stack spacing={2}>
                            <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                            >
                                {leastViewData
                                    .slice(
                                        (leastViewPage - 1) * leastViewRowsPerPage,
                                        leastViewPage * leastViewRowsPerPage
                                    )
                                    .map((customerData, index) => (
                                        <Grid item xs={2} sm={4} md={4} key={index}>
                                            <ExploreCard
                                                customerData={customerData}
                                                status={getContactStatus(customerData.update_date)}
                                                journeyRoute={getJourneyRoute(customerData.journey_type)}
                                                tagId={localStorage.getItem("tag_id")}
                                                showLastContact
                                                onAddInteraction={handleOpenInteraction}
                                            />
                                        </Grid>
                                    ))}
                            </Grid>
                        </Stack>

                        <Pagination
                            count={Math.ceil(leastViewData.length / leastViewRowsPerPage)}
                            page={leastViewPage}
                            onChange={handleLeastViewPageChange}
                            variant="outlined"
                            shape="rounded"
                            sx={{
                                mt: 3,
                                display: "flex",
                                justifyContent: "center",
                            }}
                        />
                    </>
                )}

              </div>
                <div>
                <br></br><br></br>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "rgb(255,118,43)",
                    }}
                  >
                   Top 10 by Engagement Score
                  </Typography>
                  <br />
                  {topEngagementData.length > 0 ? (
                    <>
                      <Stack spacing={2}>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12 }}
                          style={{}}
                        >
                          {topEngagementData
                            .slice(
                                topEngagementOffset,
                                topEngagementOffset + topEngagementRowsPerPage
                            )
                            .map((customerData, index) => {

                              const status = getContactStatus(customerData.update_date);
                              return (
                              // <Link style={{ textDecoration: 'none' }} target="__blanck" to={`/user/findcontact/${localStorage.getItem("tag_id")}/${customerData.customer}?name=${customerData.customer}`}>
                              <Grid item xs={2} sm={4} md={4} key={index}>
                                  <ExploreCard
                                      customerData={customerData}
                                      status={getContactStatus(customerData.update_date)}
                                      journeyRoute={getJourneyRoute(customerData.journey_type)}
                                      tagId={localStorage.getItem("tag_id")}
                                      showLastContact
                                      onAddInteraction={handleOpenInteraction}
                                  />
                              </Grid>
                              // </Link>
                            )})}
                        </Grid>
                      </Stack>
                      <Pagination
                        count={Math.ceil(topEngagementData.length / topEngagementRowsPerPage)}
                        page={topEngagementPage}
                        onChange={handleTopEngagementPageChange}
                        variant="outlined"
                        shape="rounded"
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      />
                    </>
                  ) : (
                    <Typography variant="body1" align="center" sx={{ py: 4 }}>
                        Loading...
                    </Typography>
                  )}
                </div>

                <div>
                   <br /> <br />
                   <ToggleButtonGroup
                      value={firstContactFilter}
                      exclusive
                      disabled={firstContactLoading}
                      onChange={(e, value) => {
                          if (value) {
                            setFirstContactPage(1);
                            setFirstContactFilter(value);
                          }
                      }}
                      sx={{
                          mb: 3,
                          display: "flex",
                          justifyContent: "center"
                      }}
                  >

                  <ToggleButton value="30days">
                  30 Days
                  </ToggleButton>

                  <ToggleButton value="60days">
                  60 Days
                  </ToggleButton>

                  <ToggleButton value="90days">
                  90 Days
                  </ToggleButton>

                  <ToggleButton value="thisYear">
                  This Year
                  </ToggleButton>

                  <ToggleButton value="lastYear">
                  Last Year
                  </ToggleButton>

                  </ToggleButtonGroup>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "rgb(255,118,43)",
                    }}
                  >
                   {filterTitles[firstContactFilter]}
                  </Typography>
                  <br />
                  {firstContactLoading ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 250,
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : firstContactData.length > 0 ? (
                    <>
                      <Stack spacing={2}>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12 }}
                          style={{}}
                        >
                          {firstContactData
                            .slice(
                                firstContactOffset,
                                firstContactOffset + firstContactRowsPerPage
                            )
                            .map((customerData, index) => {
                              const status = getContactStatus(customerData.update_date);
                              return (
                                // <Link style={{ textDecoration: 'none' }} target="__blanck" to={`/user/findcontact/${localStorage.getItem("tag_id")}/${customerData.customer}?name=${customerData.customer}`}>
                                <Grid item xs={2} sm={4} md={4} key={index}>
                                  <ExploreCard
                                      customerData={customerData}
                                      status={getContactStatus(customerData.update_date)}
                                      journeyRoute={getJourneyRoute(customerData.journey_type)}
                                      tagId={localStorage.getItem("tag_id")}
                                      showFirstContact
                                      showLastContact={false}
                                      onAddInteraction={handleOpenInteraction}
                                  />
                              </Grid>
                              // </Link>
                            )})}
                        </Grid>
                      </Stack>
                      <Pagination
                        count={Math.ceil(firstContactData.length / firstContactRowsPerPage)}
                        page={firstContactPage}
                        onChange={handlefirstContactPageChange}
                        variant="outlined"
                        shape="rounded"
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      />
                    </>
                  ) : (
                    <Typography variant="body1" align="center" sx={{ py: 4 }}>
                        Loading...
                    </Typography>
                  )}
                </div>
                <div>
                  <br></br><br></br>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "2rem",
                        fontWeight: "bold",
                        color: "rgb(255,118,43)",
                    }}
                >
                    Browse by Last Stage of Interaction
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        gap: 2,
                        mb: 4,
                        mt: 2,
                    }}
                >
                    {lastStageSummary.map((item) => (
                        <Chip
                            key={item.stage}
                            label={`${item.stage} (${item.count})`}
                            clickable
                            color={
                                selectedStage === item.stage
                                    ? "primary"
                                    : "default"
                            }
                            onClick={() => {
                                setSelectedStage(item.stage);
                                setStagePage(1);
                            }}
                        />
                    ))}
                </Box>
                  <br />
                  {selectedStage && filteredStageCustomers.length > 0 ? (
                    <>
                      <Stack spacing={2}>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12 }}
                          style={{}}
                        >
                          {filteredStageCustomers
                            .slice(
                                stageOffset, stageOffset + stageRowsPerPage
                            )
                            .map((customerData, index) => {

                              const status = getContactStatus(customerData.update_date);
                              return (
                              // <Link style={{ textDecoration: 'none' }} target="__blanck" to={`/user/findcontact/${localStorage.getItem("tag_id")}/${customerData.customer}?name=${customerData.customer}`}>
                              <Grid item xs={2} sm={4} md={4} key={index}>
                                <ExploreCard
                                    customerData={customerData}
                                    status={getContactStatus(customerData.update_date)}
                                    journeyRoute={getJourneyRoute(customerData.journey_type || journeyType)}
                                    tagId={localStorage.getItem("tag_id")}
                                    showLastContact
                                    onAddInteraction={handleOpenInteraction}
                                />
                            </Grid>
                              // </Link>
                            )})}
                        </Grid>
                      </Stack>
                      <Pagination
                        count={Math.ceil(filteredStageCustomers.length / stageRowsPerPage)}
                        page={stagePage}
                        onChange={handleStagePageChange}
                        variant="outlined"
                        shape="rounded"
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      />
                    </>
                  ) : (
                    <Typography variant="body1" align="center" sx={{ py: 4 }}>
                        Loading...
                    </Typography>
                  )}
                </div>
                <div>

                <br /><br />

                <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                        display:"flex",
                        justifyContent:"center",
                        fontSize:"2rem",
                        fontWeight:"bold",
                        color:"rgb(255,118,43)"
                    }}
                >

                {knownSinceTitles[knownSinceFilter]}

                </Typography>

                <ToggleButtonGroup
                    value={knownSinceFilter}
                    exclusive
                    onChange={(e, value) => {
                        if (value) {
                            setKnownSincePage(1);
                            setKnownSinceFilter(value);
                        }
                    }}
                    sx={{
                        mb:3,
                        display:"flex",
                        justifyContent:"center"
                    }}
                >

                <ToggleButton value="2021-present">
                  2021 - Present
                </ToggleButton>

                <ToggleButton value="2010-2020">
                  2010 - 2020
                </ToggleButton>

                <ToggleButton value="2000-2010">
                  2000 - 2010
                </ToggleButton>

                </ToggleButtonGroup>

                <br />

                {
                  knownSinceLoading ? (

                  <Box
                  sx={{
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center",
                  height:250
                  }}
                  >
                  <CircularProgress/>
                  </Box>

                  ) : knownSinceData.length > 0 ? (

                  <>

                  <Stack spacing={2}>

                  <Grid
                  container
                  spacing={{xs:2,md:3}}
                  columns={{xs:4,sm:8,md:12}}
                  >

                  {
                  knownSinceData
                  .slice(
                  knownSinceOffset,
                  knownSinceOffset + knownSinceRowsPerPage
                  )
                  .map((customerData,index)=>(

                  <Grid item xs={2} sm={4} md={4} key={index}>

                  <ExploreCard
                  customerData={customerData}
                  status={getContactStatus(customerData.update_date)}
                  journeyRoute={getJourneyRoute(customerData.journey_type || journeyType)}
                  tagId={localStorage.getItem("tag_id")}
                  showKnownSince
                  showLastContact={false}
                  onAddInteraction={handleOpenInteraction}
                  />

                  </Grid>

                  ))
                  }

                  </Grid>

                  </Stack>

                  <Pagination
                  count={Math.ceil(knownSinceData.length/knownSinceRowsPerPage)}
                  page={knownSincePage}
                  onChange={handleKnownSincePageChange}
                  variant="outlined"
                  shape="rounded"
                  sx={{
                  mt:3,
                  display:"flex",
                  justifyContent:"center"
                  }}
                  />

                  </>

                  ) : (

                  <Typography
                  variant="body1"
                  align="center"
                  sx={{py:4}}
                  >
                  No Data Found
                  </Typography>

                  )
                  }

                </div>
                <div>

                <br /><br />

                <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                        display:"flex",
                        justifyContent:"center",
                        fontSize:"2rem",
                        fontWeight:"bold",
                        color:"rgb(255,118,43)"
                    }}
                >
                    Contacts without Dossier
                </Typography>
                <br />

                {
                contactsWithoutDossierLoading ? (

                <Box
                sx={{
                display:"flex",
                justifyContent:"center",
                alignItems:"center",
                height:250
                }}
                >
                <CircularProgress/>
                </Box>

                ) : contactsWithoutDossierData.length > 0 ? (

                <>

                <Stack spacing={2}>

                <Grid
                container
                spacing={{xs:2,md:3}}
                columns={{xs:4,sm:8,md:12}}
                >

                {
                contactsWithoutDossierData
                .slice(
                contactsWithoutDossierOffset,
                contactsWithoutDossierOffset +
                contactsWithoutDossierRowsPerPage
                )
                .map((customerData,index)=>(

                <Grid item xs={2} sm={4} md={4} key={index}>

                <ExploreCard
                customerData={customerData}
                status={getContactStatus(customerData.update_date)}
                journeyRoute={getJourneyRoute(customerData.journey_type || journeyType)}
                tagId={localStorage.getItem("tag_id")}
                showLastContact
                onAddInteraction={handleOpenInteraction}
                />

                </Grid>

                ))
                }

                </Grid>

                </Stack>

                <Pagination
                count={Math.ceil(
                contactsWithoutDossierData.length /
                contactsWithoutDossierRowsPerPage
                )}
                page={contactsWithoutDossierPage}
                onChange={handleContactsWithoutDossierPageChange}
                variant="outlined"
                shape="rounded"
                sx={{
                mt:3,
                display:"flex",
                justifyContent:"center"
                }}
                />

                </>

                ) : (

                <Typography
                variant="body1"
                align="center"
                sx={{py:4}}
                >
                No Data Found
                </Typography>

                )
                }
                </div>
                <div>

                <Box sx={{ mt: 6 }}>

                  <Typography
                  variant="h5"
                  sx={{
                  mb:3,
                  fontWeight:"bold",
                  color:"rgb(255,118,43)",
                  textAlign:"center"
                  }}
                  >
                  Browse by Tags (more than 10 contacts)
                  </Typography>

                  <Box
                  sx={{
                  display:"flex",
                  justifyContent:"center",
                  flexWrap:"wrap",
                  gap:2,
                  mb:4
                  }}
                  >

                  {browseTags.map((tag)=>(

                  <Chip

                  key={tag.tag_id}

                  label={`${tag.tag_name} (${tag.contact_count})`}

                  clickable

                  color={
                  selectedTag?.tag_id===tag.tag_id
                  ?"primary"
                  :"default"
                  }

                  onClick={()=>{

                  setSelectedTag(tag);

                  setBrowseTagPage(1);

                  loadTagContacts(
                  tag.tag_id
                  );

                  }}

                  />

                  ))}

                  </Box>

                  {
                  browseTagContactsLoading ? (

                  <Box
                  sx={{
                  display:"flex",
                  justifyContent:"center",
                  height:250,
                  alignItems:"center"
                  }}
                  >

                  <CircularProgress/>

                  </Box>

                  ):(

                  <>

                  <Stack spacing={2}>

                  <Grid
                  container
                  spacing={{xs:2,md:3}}
                  columns={{xs:4,sm:8,md:12}}
                  >

                  {
                  browseTagContacts
                  .slice(
                  browseTagOffset,
                  browseTagOffset+
                  browseTagRowsPerPage
                  )
                  .map((customer,index)=>(

                  <Grid
                  item
                  xs={2}
                  sm={4}
                  md={4}
                  key={index}
                  >

                  <ExploreCard

                  customerData={customer}

                  status={getContactStatus(
                  customer.update_date
                  )}

                  journeyRoute={getJourneyRoute(
                  customer.journey_type
                  )}

                  tagId={
                  localStorage.getItem("tag_id")
                  }

                  showLastContact

                  onAddInteraction={
                  handleOpenInteraction
                  }

                  />

                  </Grid>

                  ))
                  }

                  </Grid>

                  </Stack>

                  <Pagination

                  count={Math.ceil(
                  browseTagContacts.length/
                  browseTagRowsPerPage
                  )}

                  page={browseTagPage}

                  onChange={
                  handleBrowseTagPageChange
                  }

                  sx={{
                  mt:3,
                  display:"flex",
                  justifyContent:"center"
                  }}

                  />

                  </>

                  )}

                  </Box>
                </div>
                {journeyType === "Customer" && (
                <div>

                  <br />
                  <br />

                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "rgb(255,118,43)"
                    }}
                  >
                    Customers with Action Plan
                  </Typography>

                  <br />

                  {customersWithActionPlanLoading ? (

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 250
                      }}
                    >
                      <CircularProgress />
                    </Box>

                  ) : customersWithActionPlanData.length > 0 ? (

                    <>

                      <Stack spacing={2}>

                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12 }}
                        >

                          {customersWithActionPlanData
                            .slice(
                              customersWithActionPlanOffset,
                              customersWithActionPlanOffset +
                                customersWithActionPlanRowsPerPage
                            )
                            .map((customerData, index) => (

                              <Grid
                                item
                                xs={2}
                                sm={4}
                                md={4}
                                key={index}
                              >

                                <ExploreCard
                                  customerData={customerData}
                                  status={getContactStatus(
                                    customerData.update_date
                                  )}
                                  journeyRoute={getJourneyRoute(
                                    customerData.journey_type ||
                                    journeyType
                                  )}
                                  tagId={localStorage.getItem("tag_id")}
                                  showLastContact
                                  onAddInteraction={
                                    handleOpenInteraction
                                  }
                                />

                              </Grid>

                            ))}

                        </Grid>

                      </Stack>

                      <Pagination
                        count={Math.ceil(
                          customersWithActionPlanData.length /
                            customersWithActionPlanRowsPerPage
                        )}
                        page={customersWithActionPlanPage}
                        onChange={
                          handleCustomersWithActionPlanPageChange
                        }
                        variant="outlined"
                        shape="rounded"
                        sx={{
                          mt: 3,
                          display: "flex",
                          justifyContent: "center"
                        }}
                      />

                    </>

                  ) : (

                    <Typography
                      variant="body1"
                      align="center"
                      sx={{ py: 4 }}
                    >
                      No Customers with Action Plan
                    </Typography>

                  )}

                </div>
                )}
                {journeyType === "Customer" && (
                <div>

                  <br />
                  <br />

                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "rgb(255,118,43)"
                    }}
                  >
                    Customers without Action Plan
                  </Typography>

                  <br />

                  {customersWithoutActionPlanLoading ? (

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 250
                      }}
                    >
                      <CircularProgress />
                    </Box>

                  ) : customersWithoutActionPlanData.length > 0 ? (

                    <>

                      <Stack spacing={2}>

                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12 }}
                        >

                          {customersWithoutActionPlanData
                            .slice(
                              customersWithoutActionPlanOffset,
                              customersWithoutActionPlanOffset +
                                customersWithoutActionPlanRowsPerPage
                            )
                            .map((customerData, index) => (

                              <Grid
                                item
                                xs={2}
                                sm={4}
                                md={4}
                                key={index}
                              >

                                <ExploreCard
                                  customerData={customerData}
                                  status={getContactStatus(
                                    customerData.update_date
                                  )}
                                  journeyRoute={getJourneyRoute(
                                    customerData.journey_type ||
                                    journeyType
                                  )}
                                  tagId={localStorage.getItem("tag_id")}
                                  showLastContact
                                  onAddInteraction={
                                    handleOpenInteraction
                                  }
                                />

                              </Grid>

                            ))}

                        </Grid>

                      </Stack>

                      <Pagination
                        count={Math.ceil(
                          customersWithoutActionPlanData.length /
                            customersWithoutActionPlanRowsPerPage
                        )}
                        page={customersWithoutActionPlanPage}
                        onChange={
                          handleCustomersWithoutActionPlanPageChange
                        }
                        variant="outlined"
                        shape="rounded"
                        sx={{
                          mt: 3,
                          display: "flex",
                          justifyContent: "center"
                        }}
                      />

                    </>

                  ) : (

                    <Typography
                      variant="body1"
                      align="center"
                      sx={{ py: 4 }}
                    >
                      No Customers without Action Plan
                    </Typography>

                  )}

                </div>
                )}
                </>
              )}
              {viewMode === "kanban" && (

                <Box
                  sx={{
                      display: "flex",
                      gap: 3,
                      overflowX: "auto",
                      overflowY: "hidden",
                      width: "100%",
                      pb: 2,
                      px: 1,
                  }}
              >

                {kanbanData.map((column) => (

                <Box
                    key={column.stage}
                    sx={{
                        width: 300,
                        minWidth: 300,
                        maxWidth: 360,
                        flexShrink: 0,
                    }}
                >

                <Typography
                    variant="h6"
                    fontWeight="bold"
                    mb={2}
                >
                    {column.stage} ({column.customers.length})
                </Typography>
                
                <Stack spacing={2}>
                {column.customers.map((customerData) => {

                    const status = getContactStatus(customerData.update_date);

                    return (

                        <ExploreCard
                            key={customerData.external_id}
                            customerData={customerData}
                            status={status}
                            journeyRoute={getJourneyRoute(customerData.journey_type || journeyType)}
                            tagId={localStorage.getItem("tag_id")}
                            width="100%"
                            variant="kanban"
                            onAddInteraction={handleOpenInteraction}
                        />

                    );

                })}
                </Stack>
                </Box>

                ))}

                </Box>

                )}

                {viewMode === "grid" && (
                  <>
                  <Typography
                      variant="h5"
                      sx={{
                          mt: 2,
                          mb: 2,
                          fontWeight: "bold",
                          color: "rgb(255,118,43)",
                      }}
                  >
                      Recently Viewed
                  </Typography>

                  {firstContactLoading ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: 200,
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <ExploreGrid rows={prepareGridRows(uniqueData)} />
                )}
                  <Typography
                    variant="h5"
                    sx={{
                        mt: 5,
                        mb: 2,
                        fontWeight: "bold",
                        color: "rgb(255,118,43)",
                    }}
                >
                    Least Viewed
                </Typography>

                {firstContactLoading ? (
                  <Box
                      sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: 200,
                      }}
                  >
                      <CircularProgress />
                  </Box>
              ) : (
                  <ExploreGrid rows={prepareGridRows(leastViewData)} />
              )}
                  <Typography
                      variant="h5"
                      sx={{
                          mt: 2,
                          mb: 2,
                          fontWeight: "bold",
                          color: "rgb(255,118,43)",
                      }}
                  >
                      Top 10 by Engagement Score
                  </Typography>

                  <ExploreGrid
                      rows={prepareGridRows(topEngagementData)}
                  />

                  <Box sx={{ mt: 5 }}>

                    <Typography
                        variant="h5"
                        sx={{
                            mb: 2,
                            fontWeight: "bold",
                            color: "rgb(255,118,43)",
                        }}
                    >
                        {filterTitles[firstContactFilter]}
                    </Typography>

                    <ToggleButtonGroup
                        value={firstContactFilter}
                        exclusive
                        disabled={firstContactLoading}
                        onChange={(e, value) => {
                            if (value) {
                                setFirstContactPage(1);
                                setFirstContactFilter(value);
                            }
                        }}
                        sx={{
                            mb: 3,
                            display: "flex"
                        }}
                    >
                        <ToggleButton value="30days">30 Days</ToggleButton>
                        <ToggleButton value="60days">60 Days</ToggleButton>
                        <ToggleButton value="90days">90 Days</ToggleButton>
                        <ToggleButton value="thisYear">This Year</ToggleButton>
                        <ToggleButton value="lastYear">Last Year</ToggleButton>
                    </ToggleButtonGroup>

                    <ExploreGrid
                        rows={prepareGridRows(firstContactData)}
                    />

                    </Box>
                    
                    <Box sx={{ mt: 5 }}>

                      <Typography
                          variant="h5"
                          sx={{
                              mb: 3,
                              fontWeight: "bold",
                              color: "rgb(255,118,43)",
                          }}
                      >
                          Browse by Last Stage of Interaction
                      </Typography>

                      <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: 2,
                            mb: 4,
                            mt: 2,
                        }}
                    >
                        {lastStageSummary.map((item) => (
                            <Chip
                                key={item.stage}
                                label={`${item.stage} (${item.count})`}
                                clickable
                                color={
                                    selectedStage === item.stage
                                        ? "primary"
                                        : "default"
                                }
                                onClick={() => {
                                    setSelectedStage(item.stage);
                                }}
                            />
                        ))}
                    </Box>
                      
                      <Box
                          sx={{
                              display: "flex",
                              justifyContent: "center",
                              flexWrap: "wrap",
                              gap: 2,
                              mb: 4,
                              mt: 2,
                          }}
                      >

                      <ExploreGrid
                            rows={prepareGridRows(filteredStageCustomers)}
                        />
                      </Box>

                      </Box>
                      <Box sx={{ mt:5 }}>

                        <Typography
                      variant="h5"
                      sx={{
                      mb:2,
                      fontWeight:"bold",
                      color:"rgb(255,118,43)"
                      }}
                      >

                      {knownSinceTitles[knownSinceFilter]}

                      </Typography>

                      <ToggleButtonGroup
                      value={knownSinceFilter}
                      exclusive
                      onChange={(e,value)=>{

                      if(value){

                      setKnownSincePage(1);

                      setKnownSinceFilter(value);

                      }

                      }}

                      sx={{
                      mb:3,
                      display:"flex"
                      }}

                      >
                        <ToggleButton value="2021-present">
                      2021-Present
                      </ToggleButton>

                      <ToggleButton value="2010-2020">
                      2010-2020
                      </ToggleButton>

                      <ToggleButton value="2000-2010">
                      2000-2010
                      </ToggleButton>

                      
                      </ToggleButtonGroup>


                      {
                        knownSinceLoading ? (

                        <Box
                        sx={{
                        display:"flex",
                        justifyContent:"center",
                        alignItems:"center",
                        height:200
                        }}
                        >
                        <CircularProgress/>
                        </Box>

                        ) : knownSinceData.length > 0 ? (

                        <ExploreGrid
                        rows={prepareGridRows(knownSinceData)}
                        showKnownSince
                        />

                        ) : (

                        <Typography
                        variant="body1"
                        align="center"
                        sx={{py:4}}
                        >
                        No Data Found
                        </Typography>

                        )
                        }

                      </Box>
                      <Box sx={{ mt:5 }}>

                        <Typography
                        variant="h5"
                        sx={{
                        mb:2,
                        fontWeight:"bold",
                        color:"rgb(255,118,43)"
                        }}
                        >
                        Contacts without Dossier
                        </Typography>

                        {
                        contactsWithoutDossierLoading ? (

                        <Box
                        sx={{
                        display:"flex",
                        justifyContent:"center",
                        alignItems:"center",
                        height:200
                        }}
                        >
                        <CircularProgress/>
                        </Box>

                        ) : contactsWithoutDossierData.length > 0 ? (

                        <ExploreGrid
                        rows={prepareGridRows(
                        contactsWithoutDossierData
                        )}
                        />

                        ) : (

                        <Typography
                        variant="body1"
                        align="center"
                        sx={{py:4}}
                        >
                        No Data Found
                        </Typography>

                        )
                        }

                        </Box>
                        <Box sx={{ mt: 5 }}>

                          <Typography
                              variant="h5"
                              sx={{
                                  mb: 2,
                                  fontWeight: "bold",
                                  color: "rgb(255,118,43)",
                              }}
                          >
                              Browse by Tags (more than 10 contacts)
                          </Typography>

                          <Box
                              sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 2,
                                  mb: 3,
                              }}
                          >
                              {browseTags.map((tag) => (
                                  <Chip
                                      key={tag.tag_id}
                                      label={`${tag.tag_name} (${tag.contact_count})`}
                                      clickable
                                      color={
                                          selectedTag?.tag_id === tag.tag_id
                                              ? "primary"
                                              : "default"
                                      }
                                      onClick={() => {
                                          setSelectedTag(tag);
                                          loadTagContacts(tag.tag_id);
                                      }}
                                  />
                              ))}
                          </Box>

                          {browseTagContactsLoading ? (

                              <Box
                                  sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      py: 4,
                                  }}
                              >
                                  <CircularProgress />
                              </Box>

                          ) : (

                              <ExploreGrid
                                  rows={prepareGridRows(browseTagContacts)}
                              />

                          )}

                      </Box>
                      {journeyType === "Customer" && (
                      <Box sx={{ mt: 5 }}>

                        <Typography
                          variant="h5"
                          sx={{
                            mb: 2,
                            fontWeight: "bold",
                            color: "rgb(255,118,43)"
                          }}
                        >
                          Customers with Action Plan
                        </Typography>

                        {customersWithActionPlanLoading ? (

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              py: 4
                            }}
                          >
                            <CircularProgress />
                          </Box>

                        ) : (

                          <ExploreGrid
                            rows={prepareGridRows(
                              customersWithActionPlanData
                            )}
                          />

                        )}

                      </Box>
                      )}
                      {journeyType === "Customer" && (
                      <Box sx={{ mt: 5 }}>

                        <Typography
                          variant="h5"
                          sx={{
                            mb: 2,
                            fontWeight: "bold",
                            color: "rgb(255,118,43)"
                          }}
                        >
                          Customers without Action Plan
                        </Typography>

                        {customersWithoutActionPlanLoading ? (

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              py: 4
                            }}
                          >
                            <CircularProgress />
                          </Box>

                        ) : (

                          <ExploreGrid
                            rows={prepareGridRows(
                              customersWithoutActionPlanData
                            )}
                          />

                        )}

                      </Box>
                      )}
                      </>
                    )}
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "80px",
              }}
            >
              <div sx={{ display: "flex" }}>
                <CircularProgress />
              </div>
              <p>Loading</p>
            </div>
          )}
        </Container>
      </div>
      <AddInteractionDialog
          open={openInteractionModal}
          onClose={() => setOpenInteractionModal(false)}
          implId={impl_id}
          implementationName={select}
          journeyType={journeyType}
          selectedCustomer={selectedCustomer}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "80px",
        }}
      >
        <Footer />
      </div>
    </>
  );
};

export default ExploreJourney;